import { useEffect } from 'react';

/**
 * Escape-to-close and a scroll lock for the two right-docked panels while they
 * are showing as a bottom sheet on a phone.
 *
 * They are not Radix Sheets. Converting them means remounting through a portal,
 * which moves the agent chat's scroll-restore and the notes panel's pending
 * prepend — the two most stateful pieces in the app. This covers the part of
 * the gap that does not need that surgery; a focus trap still does, and is
 * tracked in docs/ui-migration-plan.md.
 */
export function useMobileSheet(active: boolean, onClose: () => void) {
  useEffect(() => {
    if (!active) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [active, onClose]);
}
